<template>
  <v-container>
    <v-card class="mx-auto pa-4">
      <div v-if="loading || items.length == 0" class="display-1 text--primary">
        <v-icon>list_alt</v-icon>
        Other/Vendor Lists ({{ loading ? '...' : items.length }})
      </div>

      <v-expansion-panels v-else>
        <v-expansion-panel>
          <v-expansion-panel-header class="display-1 text--primary">
            <div>
              <v-icon>list_alt</v-icon>
              Other/Vendor Lists ({{ items.length }})
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table dense :headers="headers" :items="items" item-key="id"
              :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }" :items-per-page="25">
              <template v-slot:item.listCreatedUtc="{ item }">
                {{ item.listCreatedUtc | toDateOnly }}
              </template>
              <template v-slot:item.model="{ item }">
                {{ models(item) }}
              </template>
              <template v-slot:item.price="{ item }">
                {{ item.price | toCurrency }}
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-container>
</template>

<script>
import { CatCodesService } from '../../services/api/catCodes';
const apiCatCodes = new CatCodesService();

export default {
  props: {
    catCodeString: String,
  },

  data() {
    return {
      loading: true,
      items: [],
      headers: [
        { text: 'List', value: 'vendorListName' },
        { text: 'Date', value: 'listCreatedUtc' },
        { text: 'Model', value: 'model', sortable: false },
        { text: 'Description', value: 'description' },
        { text: 'Qty', value: 'quantity', align: 'end' },
        { text: 'Price', value: 'price', align: 'end' },
        { text: 'SPQ', value: 'spq', align: 'end' },
        { text: 'MOQ', value: 'moq', align: 'end' },
        { text: 'Condition', value: 'condition' },
        { text: 'Warranty', value: 'warranty' },
        { text: 'Lead Time', value: 'leadTime' },
      ],
    }
  },

  created() {
    apiCatCodes.getVendorListItems(this.catCodeString).then((data) => {
      this.items = data;
    }).finally(() => {
      this.loading = false;
    });
  },

  methods: {
    models(item) {
      return [item.model1, item.model2, item.model3].filter(m => m).join(' / ');
    },
  },
}
</script>
